import React from 'react'
import styled from 'styled-components'

const ApiTabsHeaderWrapper = ({ attributes, children, element }) => <TabsHeader {...attributes}>{children}</TabsHeader>

export default ApiTabsHeaderWrapper

const TabsHeader = styled.ul`
  list-style-type: none;
  display: flex;
  max-width: 100%;
  margin: 0px;
  padding: 0px;
`
